import Block from './Block'
import Draggable from 'gsap/Draggable'
import store from '../util/store'

export default class OurServices extends Block {
  getElems() {
    this.container = this.el.querySelector('.b-our-services__items')
    this.draggable = this.el.querySelector('.b-our-services__items__inner')
  }

  init() {
    const isDesktop = window.matchMedia('(min-width: 768px)').matches

    if (isDesktop && this.draggable) {
      Draggable.create(this.draggable, {
        bounds: this.container,
        type: 'x',
        inertia: true
      })
    }
  }

  events() {
    this.container.addEventListener('mouseenter', () => {
      store.cursor.addState('-xl')
      store.cursor.setIcon('resources--assets--images--svg--arrow-double-white')
    })

    this.container.addEventListener('mouseleave', () => {
      store.cursor.removeState('-xl')
      store.cursor.removeIcon()
    })
  }
}
